// extracted by mini-css-extract-plugin
export var body = "EditProduct-module--body--MHvEn";
export var container = "EditProduct-module--container--as+E4";
export var footer = "EditProduct-module--footer--gkKSn";
export var header = "EditProduct-module--header--EPsPI";